import BaseService from './base.service';

export default class LogService extends BaseService {
  create(logData) {
    try {
      return this.post(`/logs`, logData);
    } catch (error) {
      return null;
    }
  }

  userReportLinkUsed(resourceId) {
    return this.post(`/logs/resources/${resourceId}`);
  }
}
